import { trackEvent, trackPageview } from "@garantidos/utils/tracking"

const pageview = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/simular-credito-com-resultados",
    hashedCpf,
    implementationTeam: "cgi:v01"
  }

  const ga = {
    label: "IT:NL:NCC:CGI:Simulador:SimularCreditoComResultados",
    hashedCpf
  }

  const segment = {
    event: "Simulation View"
  }

  trackPageview({ ga4, ga, segment })
}

const doSimulation = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/simular-credito-com-resultados",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "simular-credito-e-obter-resultados",
    eventName: "click"
  }

  const ga = {
    label: "BTN:Simulador:SimularCreditoEObterResultados",
    action: "Simulador",
    hashedCpf
  }

  trackEvent({ ga, ga4, segment: "Simulation Sent" })
}

const resultsLoaded = () => {
  const segment = {
    event: "Simulation Completed"
  }

  trackEvent({ segment })
}

const seePriceDetails = () => {
  const segment = {
    event: "Simulação Price Clicou Botão Detalhes"
  }

  trackEvent({ segment })
}

const seeSacDetails = () => {
  const segment = {
    event: "Simulação SAC Clicou Botão Detalhes"
  }

  trackEvent({ segment })
}

const choiceResult = () => {
  const ga = {
    label: "BTN:Simulador:CliqueSolicitarAnalise",
    action: "Simulador"
  }

  const segment = {
    event: "Proposal Started"
  }

  trackEvent({ ga, segment })
}

const alert = (hashedCpf, error) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/simular-credito-com-resultados",
    hashedCpf,
    implementationTeam: "cgi:v01",
    eventName: "alert",
    description: "erro",
    detail: error.message
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replaceAll(/ /g, "-")
      .replaceAll(/!/g, "")
  }

  trackEvent({ ga4 })
}

const back = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/simular-credito-com-resultados",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "simular-credito-voltar",
    eventName: "click"
  }

  const segment = "simulação clicou botão voltar"

  trackEvent({ ga4, segment })
}

const backToHome = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/simular-credito-com-resultados",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "simular-credito-voltar-inicio",
    eventName: "click"
  }

  const ga = {
    label: "BTN:Simulador:VoltarInicio",
    action: "Simulador",
    hashedCpf
  }

  trackEvent({ ga, ga4 })
}

export {
  pageview,
  doSimulation,
  resultsLoaded,
  choiceResult,
  alert,
  backToHome,
  back,
  seePriceDetails,
  seeSacDetails
}
